import Card2 from "../components/Card2";

import FAQ_QA from "../components/FAQ_QA";
// import DrawLine from "../components/DrawLine";
// import MainView from "../images/careerbanner.jpg";
// import Logo from "../images/common/logomain.png";
import Footer from "../components/Footer";
import careerDoc from "../images/doctors/careerDoc.png";
import tick from "../images/doctors/tick.svg";
import team from "../images/doctors/team.svg";
// import { gsap, Power3 } from "gsap";
import Contacts from "../components/Contacts";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useLayoutEffect, useRef } from "react";

import "../css/career.scss";
import NavigationBar from "../components/navigationBar";

const dummy_data = [
  {
    question: {
      position: "Lab Manager and Technical Supervisor",
      // place: "Pauls Valley, OK",
      // dept: "Surgery",
    },
    shortDesc:
      "Responsible for performing complex medical laboratory tests for diagnosis, treatment, and prevention of disease. His specific duties will include conducting chemical analysis of body fluids, including blood and urine to determine presence of abnormal components; analyzing laboratory findings to check the accuracy of the results; calibrating and maintaining specialized software and equipment used in analysis; overseeing quality assurance programs and activities to ensure the accuracy of laboratory results; analyzing samples of biological material for chemical content or reaction; validating highly complex molecular tests and other high complexity laboratory testing that requires specialized equipment and reagents and produces results that require interpretation or analysis by specialized laboratory professionals; validating clinical tests, including polymerase chain reaction (PCR) testing, to evaluate and verify the accuracy, reliability, and performance of clinical diagnostic tests; upholding health and safety protocols as required by law; supervising and training laboratory personnel; developing, standardizing, evaluating, and modifying procedures, techniques, and tests used in the analysis of specimens; and writing standard operating procedures (SOPs) for different medical tests. This position oversees seven staff, including two Molecular Laboratory Technicians, one Chemistry Technician, one Laboratory Nurse, and three part-time Laboratory Technicians.",
    detailDesc: [
      "Bachelor’s degree in biology or a closely-related life science field. (2) 24 months of experience in a clinical laboratory and/or molecular biology scientist and/or molecular biology teaching position, to include at least six months of experience with the following: (a) Polymerase chain reaction (PCR) testing, (b) High complexity laboratory testing that requires specialized equipment and reagents and/or produce results that require interpretation or analysis by specialized laboratory professionals, and (c) Clinical test validation to evaluate and verify the accuracy, reliability, and performance of clinical diagnostic tests. In lieu of bachelor’s degree plus 24 months of experience, employer will accept master’s degree in biology or a closely-related life science field plus 12 months of experience in a clinical laboratory and/or academic biology laboratory and/or molecular biology scientist position, with at least six months of experience in the listed areas. (3) Occasional regional or national travel to attend meetings, workshops, etc.",
    ],
  },
];
const Career = () => {
  console.log("In Career page");

  return (
    <>
      {/* <Contacts /> */}
      <NavigationBar />
      <div className="career">
        {/* <div
        className="topDesignElement1Capsule"
        data-aos="new-animation"
        data-aos-delay="10"
        data-aos-duration="1000"
      >
        <div className="topDesignElement1"></div>
      </div> */}
        {/* <div className="topDesignElement2">
        <div className="topDesignElement2-container">
          <div className="container2">
            <div className="topPart"></div>
            <div className="bottomPart"></div>
          </div>
          <div
            className="topDesignElement3"
          // data-aos="custom-img-animate"
          // data-aos-duration="2500"
          // data-aos-once="true"
          >
            <img src={MainView} alt="" />
          </div>
        </div>
      </div> */}
        <Card2>
          <div className="section1" npm>
            <div class="career-content-container">
              <div className="section1-title">
                Join us & Become a part of our story
              </div>
              <div className="section1-para">
                We inspire each other every day by pushing limits of what's
                possible in the field of health and medicine.
              </div>
              <div className="section1-button">
                <button className="realButton">Apply Now</button>
              </div>
            </div>
            <div class="careerDoc-container">
              <div class="internal-careerDoc">
                <div class="careerdoctor">
                  <img src={careerDoc} alt="mainview" />
                </div>

                <div class=" Cobject Cobject1">
                  <div class="Cobject1-container">
                    <div class="team">
                      <img src={team} alt="tick" className="icon" />
                    </div>
                    <div class="object-title">Join Our Dynamic Team</div>
                  </div>
                </div>

                <div class=" Cobject Cobject2">
                  <div class="Cobject1-container">
                    <div class="ticker">
                      <img src={tick} alt="tick" className="icon" />
                    </div>
                    <div class="object-title">Unleash Your Potential</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card2>

        <Card2>
          <section className="section-2">
            <div class="section2-title">Available Positions</div>
            <div className="section-2_container">
              <div className="section-2_container--description">
                {dummy_data?.map((data, index) => (
                  <>
                    {index !== 0 && (
                      <div>
                        {/* <div data-aos="fade-up" data-aos-delay="200"> */}
                        {/* <DrawLine width="100%" margin="0" height="0.2px" /> */}
                      </div>
                    )}
                    <FAQ_QA
                      question={data.question}
                      shortDesc={data.shortDesc}
                      detailDesc={data.detailDesc}
                    />
                  </>
                ))}
              </div>
            </div>
          </section>
        </Card2>
        <Footer />
      </div>
    </>
  );
};

export default Career;
